// ===================== HELPER FUNCTION DECODE TOKEN =====================
// --------------------- XOR STRING WITH DAY ---------------------
const xorStringWithDay = (str: string, day: number): string => {
    day = (day + 2) / 2 * 3 - 1
    let result = "";
    for (let i = 0; i < str.length; i++) {
        // XOR the character code with the day number
        const xorCharCode = str.charCodeAt(i) ^ day;
        // Convert the XOR result back to a character
        result += String.fromCharCode(xorCharCode);
    }
    return result;
};
// --------------------- XOR ENCODE ---------------------
export const xorEncode = (str: string, day: number): string => {
    const xorResult = xorStringWithDay(str, day);
    let hex = '';
    for (let i = 0; i < xorResult.length; i++) {
        hex += xorResult.charCodeAt(i).toString(16);
    }
    return hex;
};
// --------------------- XOR DECODE ---------------------
export const xorDecode = (hex: string, day: number): string => {
    let str = '';
    for (let i = 0; i < hex.length; i += 2) {
        const code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return xorStringWithDay(str, day);
};

// --------------------- DECODE ACCESS TOKEN ---------------------
export const decodeAccessToken = (token: string): boolean | null => {
    const day = new Date().getDate();

    const result = xorDecode(token, day);
    if (result === "priv") {
        return true;
    } else if (result === "publ") {
        return false;
    }
    return null;
}
